<div class="wrapper">
    <app-hero-section></app-hero-section>
    <app-categories-section></app-categories-section>
    <app-best-sellers-section
        [bestSellerProducts]="bestSellerProducts"
        *ngIf="bestSellerProducts.length"
    ></app-best-sellers-section>
    <app-custom-blocks-cta></app-custom-blocks-cta>
</div>
